import React from 'react';
import { useTranslation } from 'react-i18next';
import config from 'utils/config';
import getLikeLabel from 'utils/i18n/getLikeLabel';
import Icon from 'components/Icon';
import InlineList from 'components/InlineList';
import { TooltipPill, TooltipPillWithCount } from 'components/Pill';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function InfoIcons(props) {
  var isSaved = props.isSaved,
    visibility = props.visibility,
    commentCount = props.commentCount,
    commentCountUser = props.commentCountUser,
    hasUserLiked = props.hasUserLiked,
    likeCount = props.likeCount,
    isOptional = props.isOptional,
    playlistName = props.playlistName;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs(InlineList.Wrapper, {
    spacing: "xs",
    align: "top",
    children: [isOptional && /*#__PURE__*/_jsx(InlineList.Item, {
      children: /*#__PURE__*/_jsx(TooltipPill, {
        title: t('content_status_optional_info', {
          playlistName: playlistName
        }),
        children: t('content_status_optional')
      })
    }), likeCount > 0 && /*#__PURE__*/_jsx(InlineList.Item, {
      children: /*#__PURE__*/_jsx(TooltipPillWithCount, {
        title: getLikeLabel(likeCount, hasUserLiked),
        icon: "like",
        count: likeCount,
        highlightIcon: hasUserLiked
      })
    }), config.enableComments && commentCount > 0 && /*#__PURE__*/_jsx(InlineList.Item, {
      children: /*#__PURE__*/_jsx(TooltipPillWithCount, {
        title: t('comment_count', {
          count: commentCount
        }),
        icon: "chat",
        count: commentCount,
        highlightIcon: commentCountUser > 0
      })
    }), Boolean(isSaved) && /*#__PURE__*/_jsx(InlineList.Item, {
      children: /*#__PURE__*/_jsx(TooltipPill, {
        title: t('actions_saved_for_later'),
        children: /*#__PURE__*/_jsx(Icon, {
          vAlign: true,
          dimmed: true,
          name: "favourite",
          scale: 0
        })
      })
    }), Boolean(visibility) && /*#__PURE__*/_jsx(InlineList.Item, {
      children: /*#__PURE__*/_jsx(TooltipPill, {
        title: visibility === 'private' ? t('only_admins_can_see_this') : t('content_currently_not_available'),
        children: /*#__PURE__*/_jsx(Icon, {
          vAlign: true,
          dimmed: true,
          name: "eye-closed",
          scale: 0
        })
      })
    })]
  });
}
export default InfoIcons;